export default ({
  computed: {
    groupID: function () {
      return this.$route.params.groupID
    },
  },
})
